import { Component, Input, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EotmMetricService } from '../../../services/eotm-metric.service';

@Component({
  selector: 'app-paper-note',
  templateUrl: './paper-note.component.html',
  styleUrls: ['./paper-note.component.scss']
})
export class PaperNoteComponent implements OnInit {
  @ViewChild('metricModal') metricModal: any;
  @ViewChild('rankingModal') rankingModal: any;

  availableMetrics = [
    { name: 'Objective Progression', selected: false, weightage: 0 },
    { name: 'Skill Improvement', selected: false, weightage: 0 },
    // { name: 'Customer Satisfaction', selected: false, weightage: 0 },
    { name: 'Assessment Score', selected: false, weightage: 0 },
    { name: 'Training Progress', selected: false, weightage: 0 }
  ];

  @Input() data: any;
  @Input() tooltip: any;
  @Output() onMetricChange: any = new EventEmitter();

  constructor(private modalService: NgbModal, private eotmMetricService: EotmMetricService) {}

  ngOnInit() {
    console.log(this.data);
    this.loadExistingMetrics();
  }

  /**
   * Load existing metrics from the API if available.
   */
  loadExistingMetrics() {
    this.eotmMetricService.getMetrics().subscribe(
      (metrics) => {
        this.availableMetrics.forEach(metric => {
          const existingMetric = metrics.find((m: any) => m.name === metric.name);
          if (existingMetric) {
            metric.selected = existingMetric.selected;
            metric.weightage = existingMetric.selected ? existingMetric.weightage : 0; // Reset if unselected
          }
        });
      },
      (error) => {
        console.error('Error fetching metrics:', error);
      }
    );
  }

  openModal() {
    this.modalService.open(this.metricModal, { centered: true });
  }

  openRankingModal() {
    this.modalService.open(this.rankingModal, { centered: true, size: 'lg' });
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  /**
   * Handle checkbox change to reset weightage if unchecked
   */
  onCheckboxChange(metric: any) {
    if (!metric.selected) {
      metric.weightage = 0;
    }
  }

  /**
   * Save all metrics (selected and unselected) to the backend
   */
  saveMetrics() {
    const metricsToSave = this.availableMetrics.map(m => ({
      name: m.name,
      selected: m.selected,
      weightage: m.selected ? m.weightage || 0 : 0 // Ensure weightage is 0 if not selected
    }));

    this.eotmMetricService.saveMetric({ metrics: metricsToSave }).subscribe(
      (response) => {
        console.log('Metrics saved successfully:', response);
        alert('All metrics saved successfully!');
        this.onMetricChange.emit(metricsToSave); // Emit the selected metrics
        this.modalService.dismissAll();
      },
      (error) => {
        console.error('Error saving metrics:', error);
        alert('Failed to save metrics.');
      }
    );
  }
}
